import { MaterializedProcessesDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  BulkCreateMaterializedProcessDocument,
  BulkCreateMaterializedProcessMutation,
  BulkCreateMaterializedProcessMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useBulkCreateMaterializedProcess = () => {
  const [BulkCreateMaterializedProcesses, { loading }] = useMutation(
    BulkCreateMaterializedProcessDocument,
    {
      extractorFn: (data: BulkCreateMaterializedProcessMutation) =>
        data.processesMutations.bulkCreateProcessesMaterializedProcess,
    }
  )

  return {
    loading,
    bulkCreateMaterializedProcesses(variables: BulkCreateMaterializedProcessMutationVariables) {
      return BulkCreateMaterializedProcesses({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: MaterializedProcessesDataTableDocument,
            variables: {
              processId: variables.processId,
            },
          },
        ],
      })
    },
  }
}
